import { BaseService } from "./baseService";
class UploadEmployeeErrorsService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "upload_employee_error";
    }
}
export const uploadEmployeeErrorsService = new UploadEmployeeErrorsService();
//# sourceMappingURL=uploadEmployeeErrorsService.js.map